import { Helmet } from 'react-helmet-async';
import { useState } from 'react';
// @mui
import { Container, Stack, Typography, Card } from '@mui/material';
// components
import { ProductSort, ProductList, ProductCartWidget, ProductFilterSidebar } from '../sections/@dashboard/products';
// mock
import PRODUCTS from '../_mock/products';

// ----------------------------------------------------------------------

export default function ProductsPage() {
  const [openFilter, setOpenFilter] = useState(false);

  const handleOpenFilter = () => {
    setOpenFilter(true);
  };

  const handleCloseFilter = () => {
    setOpenFilter(false);
  };

  return (
    <>
      <Helmet>
        <title> Buy Number | BizNumber </title>
      </Helmet>

      <Container>
        <Typography variant="h4" sx={{ mb: 5 }}>
          Products
        </Typography>

        <ProductList products={PRODUCTS} />

        {/* add helper card include warning text and detail */}
        <Card sx={{ p: 3, mt: 5 }}>
          <Typography variant="body2" sx={{ color: 'text.secondary' }}>
            The price does not change according to the country of sale. After purchasing, you can choose the country you
            want, which is available.
            {/* new line */}
            <br />
            The above items are one-time fees, non-renewable. In order to use the numbers, your wanum subscription must
            be active.
          </Typography>
        </Card>
      </Container>
    </>
  );
}
